import { User } from '@wellesley/openapi'
import { ListItem } from '../types'

export const isUser = (item: ListItem): item is User => {
  return typeof item === 'object' && 'id' in item
}

export const checkIsItemSelected = (
  selectedList: ListItem[],
  item: ListItem,
): boolean => {
  return selectedList.some((value) => {
    if (isUser(value) && isUser(item)) {
      return value.id === item.id
    }
    return value === item
  })
}
